import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import TransactionRequest from '../transactions/TransactionRequest';
import { decodeTransactionPath } from './path/decodePath';
import { tryEvaluatingRadspec, postprocessRadspecDescription } from './radspec/index';
export function describeTransaction(_x, _x2, _x3) {
  return _describeTransaction.apply(this, arguments);
}
/**
 * Use radspec to create a human-readable description for each transaction in the given `path`
 *
 */

function _describeTransaction() {
  _describeTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(transaction, apps, provider) {
    var description, descriptionAnnotated, processed;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (transaction.to) {
              _context.next = 2;
              break;
            }

            throw new Error("Could not describe transaction: missing 'to'");

          case 2:
            if (transaction.data) {
              _context.next = 4;
              break;
            }

            throw new Error("Could not describe transaction: missing 'data'");

          case 4:
            _context.prev = 4;
            _context.next = 7;
            return tryEvaluatingRadspec(transaction, apps, provider);

          case 7:
            description = _context.sent;

            if (!description) {
              _context.next = 14;
              break;
            }

            _context.next = 11;
            return postprocessRadspecDescription(description, apps);

          case 11:
            processed = _context.sent;
            descriptionAnnotated = processed.annotatedDescription;
            description = processed.description;

          case 14:
            if (!transaction.children) {
              _context.next = 18;
              break;
            }

            _context.next = 17;
            return describeTransactionPath(transaction.children, apps, provider);

          case 17:
            transaction.children = _context.sent;

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](4);
            throw new Error("Could not describe transaction: ".concat(_context.t0));

          case 23:
            return _context.abrupt("return", new TransactionRequest(_objectSpread({}, transaction, {
              description: description,
              descriptionAnnotated: descriptionAnnotated
            })));

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 20]]);
  }));
  return _describeTransaction.apply(this, arguments);
}

export function describeTransactionPath(_x4, _x5, _x6) {
  return _describeTransactionPath.apply(this, arguments);
}

function _describeTransactionPath() {
  _describeTransactionPath = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(path, apps, provider) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", Promise.all(path.map(function (step) {
              return describeTransaction(step, apps, provider);
            })));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _describeTransactionPath.apply(this, arguments);
}

export function describeScript(_x7, _x8, _x9) {
  return _describeScript.apply(this, arguments);
}

function _describeScript() {
  _describeScript = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(script, apps, provider) {
    var path;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            path = decodeTransactionPath(script);
            return _context3.abrupt("return", describeTransactionPath(path, apps, provider));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _describeScript.apply(this, arguments);
}